import React from 'react';
import _ from 'lodash';
import { translate } from '@fiverr-private/i18n-react';
import {
    CollapsibleFaqs,
    Tips,
    type TipsData,
    type FAQsData,
    RelatedGuides,
    RelatedLinks,
    type RelatedLinksData,
    RelatedSkillsData,
    RelatedGuidesData,
} from '@fiverr-private/seo_content';
import { Container } from '@fiverr-private/layout_components';
import { BRAND_STYLE_GUIDE_SC_SLUG } from '../../../utils/constants';
import './index.scss';

interface SeoSubCategoryProps {
    title: string;
    faqs?: FAQsData;
    relatedLinksTitle?: string;
    relatedLinks?: RelatedLinksData;
    relatedSkillsTitle?: string;
    relatedSkills?: RelatedSkillsData;
    relatedGuides?: RelatedGuidesData;
    cachedSlug: string;
    tips?: TipsData;
}

const SeoSubCategory = ({
    title,
    faqs,
    relatedLinksTitle = '',
    relatedLinks,
    relatedSkillsTitle = '',
    relatedSkills,
    relatedGuides,
    cachedSlug,
    tips,
}: SeoSubCategoryProps) => {
    const relatedGuidesSourcePageKey = `subcategories_${cachedSlug}`;
    const relatedGuidesTitle =
        cachedSlug === BRAND_STYLE_GUIDE_SC_SLUG
            ? translate('search_perseus.seo_sub_category.related_guides.brand_style_guides_title')
            : translate('search_perseus.seo_sub_category.related_guides.title', {
                  params: { sub_category_title: title },
              });

    return (
        <>
            {!_.isEmpty(tips) && <Tips data={tips} subCategory={title} />}
            {relatedLinks && <RelatedLinks title={relatedLinksTitle} relatedLinks={relatedLinks} />}
            {relatedSkills && <RelatedLinks title={relatedSkillsTitle} relatedLinks={relatedSkills} openInNewTab />}
            {!_.isEmpty(faqs) && (
                <Container marginBottom="6">
                    <CollapsibleFaqs title={title} faqs={faqs} />
                </Container>
            )}
            {relatedGuides && (
                <Container marginBottom="6" overflow="hidden">
                    <RelatedGuides
                        guides={relatedGuides}
                        title={relatedGuidesTitle}
                        sourcePageKey={relatedGuidesSourcePageKey}
                    />
                </Container>
            )}
        </>
    );
};

export default SeoSubCategory;
